

/**
 * @param  {} codeString
 * Очистить JS файл от дефиниций
 */
export const TryParseJsonFromPlainCode = (codeString) => {
  const re = /\{.*\:\{.*\:.*\}\}/
  const matchResult = codeString.match(re);
  const stringresult = matchResult[0];

  if (matchResult.length === 0) {
    throw new Error("file error parse");
  }

  let jsonString;
  try {
    jsonString = JSON.parse(stringresult);
  } catch (error) {
    return {
      error
    }
  }
  return jsonString;

}